





























































import Vue from "vue";
import Component from "vue-class-component";
//import { user } from "@/store";

@Component
export default class ChangePasswordForm extends Vue {
  valid: boolean = true;
  dialog: boolean = false;
  passwordError: boolean = false;
  serverError: boolean = false;
  passwordServerError: boolean = false;
  updated: boolean = false;
  updateError: boolean = false;
  oldPassword: string = "";
  newPassword: string = "";
  newPassword2: string = "";
  timeout: number = 3000;
  passwordRules: any[] = [
    (v: string) => !!v || "Introduzca su contraseña",
    (v: string) =>
      (v && v.length >= 8) ||
      "La contraseña debe de tener al menos 8 caracteres",
  ];

  validate(): void {
    (this.$refs.form as any).validate();
    this.passwordError = this.newPassword != this.newPassword2;
  }
  send(): void {
    this.validate();
    if (this.valid && !this.passwordError) {
      const passwords = {
        old_password: this.oldPassword,
        new_password: this.newPassword,
        new_password_2: this.newPassword2,
      };
      console.log(passwords);
      this.$store
        .dispatch("changePassword", passwords)
        .then((resp) => {
          if (resp.status === 200) {
            this.updated = true;
            this.passwordServerError = false;
            this.serverError = false;
            this.passwordError = false;
            setTimeout(() => (this.dialog = false), 2000);
          }
        })
        .catch((err) => {
          if (err.status === 400) {
            this.passwordServerError = true;
          } else {
            this.serverError = true;
          }
        });
    }
  }
}
